import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import Icon from '../../components/Icons/Icon';
import { Link } from 'react-router-dom';
import { getSiteSettings } from '../../api/siteSettings';

function ServicesSlider() {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          setSiteSettings(response.data);
        }
      } catch (error) {
        console.error('Error fetching site settings:', error);
      }
    };

    fetchSiteSettings();
  }, []);
  const services = [
    {
      id: 1,
      title: 'E-İmar',
      iconName: 'imar',
      iconColor: '#084977ff',
      link: "https://keos.iskenderun.bel.tr:8787/imardurumu/index.aspx",
      isExternal: true
    },
    {
      id: 2,
      title: 'E-Belediye',
      iconName: 'world',
      iconColor: '#0F75BC',
      link: "https://webportal.iskenderun.bel.tr/engine/index.php",
      isExternal: true
    },
    {
      id: 3,
      title: 'Bize Bildir',
      iconName: 'beyaz-masa',
      iconColor: '#13A7FDFF',
      link: '/bize-bildir',
      isExternal: false
    },
    {
      id: 9,
      title: 'Kütüphane Randevu Sistemi',
      lineBreak: true, // İki satırlı başlık
      iconName: 'calendar',
      iconColor: '#8b5cf6',
      link: '/hizmet-rehberi/kutuphane-randevu',
      isExternal: false
    },
    {
      id: 6,
      title: 'Kuaför Randevu Sistemi',
      lineBreak: true, // İki satırlı başlık
      iconName: 'hairdresser-chair-svgrepo-com',
      iconColor: '#22c55e',
      link: siteSettings?.barberUrl || 'https://ebelediye.iskenderun.bel.tr/webportal/index.php?wwsayfa=8100',
      isExternal: true
    },
    {
      id: 5,
      title: 'İhaleler',
      iconName: 'forms',
      iconColor: 'rgb(246 30 30)',
      link: '/ihaleler',
      isExternal: false
    },
    {
      id: 4,
      title: 'Parklarımız',
      iconName: 'parklar',
      iconColor: '#b73cffe1',
      link: '/parklar',
      isExternal: false
    },
    {
      id: 7,
      title: 'İlanlar',
      iconName: 'guncel',
      iconColor: '#0D8830',
      link: '/ilanlar',
      isExternal: false
    },
    {
      id: 8,
      title: 'Mahallem Gelişiyor',
      iconName: 'smile',
      iconColor: '#F68B1E',
      link: '/mahalleler',
      isExternal: false
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  };

  return (
    <div className="services-slider-section">

      <Slider {...settings} className="services-slider">

        {services.map((service) => (
          service.isExternal ? (
            <a
              key={service.id}
              href={service.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="service-card">
                <div className="service-icon">
                  <Icon
                    icon={service.iconName}
                    size={48}
                    color={service.iconColor}
                  />
                </div>
                <h3 className="service-title" style={{ background: service.iconColor }}>
                  {service.lineBreak ? (
                    <>
                      {service.title.split(' ').slice(0, Math.ceil(service.title.split(' ').length / 2)).join(' ')}
                      <br />
                      {service.title.split(' ').slice(Math.ceil(service.title.split(' ').length / 2)).join(' ')}
                    </>
                  ) : (
                    service.title
                  )}
                </h3>
              </div>
            </a>
          ) : (
            <Link
              key={service.id}
              to={service.link}
            >
              <div className="service-card">
                <div className="service-icon">
                  <Icon
                    icon={service.iconName}
                    size={48}
                    color={service.iconColor}
                  />
                </div>
                <h3 className="service-title" style={{ background: service.iconColor }}>
                  {service.lineBreak ? (
                    <>
                      {service.title.split(' ').slice(0, Math.ceil(service.title.split(' ').length / 2)).join(' ')}
                      <br />
                      {service.title.split(' ').slice(Math.ceil(service.title.split(' ').length / 2)).join(' ')}
                    </>
                  ) : (
                    service.title
                  )}
                </h3>
              </div>
            </Link>
          )
        ))}
      </Slider>

    </div>
  );
}

export default ServicesSlider;
